import React, { useEffect, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const Logout = () => {
  const { signOut } = useContext(AuthContext);

  useEffect(() => {
    signOut();
  }, [signOut]);

  return <Navigate to="/login" replace />;
};

export default Logout;
